import { render, staticRenderFns } from "./ClientAddressForm.vue?vue&type=template&id=37794938&"
import script from "./ClientAddressForm.vue?vue&type=script&lang=js&"
export * from "./ClientAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientAddressForm.vue?vue&type=style&index=0&id=37794938&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports